import { useEffect, useState } from "react";
import { usePresentationConfig } from "../react/queries/usePresentationConfig";

// Full-viewport loader shown while the boot saga (me + bootstrap + locale) is
// in flight. 3×3 grid of brand-tinted tiles pulse in a diagonal-ripple rhythm,
// echoing the app-switcher tile aesthetic so the loader reads as "your
// workspace assembling itself" instead of a generic spinner. The phase text
// below cycles every 2.4s through a short sequence so the user sees motion
// even on slow connections without it feeling like noise.
const PHASES = [
    "Signing you in",
    "Loading workspace",
    "Preparing your apps",
    "Almost ready",
];

export function WorkspaceLoader() {
    const { data: branding } = usePresentationConfig();
    const [phaseIdx, setPhaseIdx] = useState(0);

    useEffect(() => {
        const id = window.setInterval(() => {
            setPhaseIdx((i) => (i + 1) % PHASES.length);
        }, 2400);
        return () => window.clearInterval(id);
    }, []);

    return (
        <div className="workspace-loader" role="status" aria-live="polite">
            <div className="workspace-loader__brand">
                <div className="workspace-loader__grid">
                    {Array.from({ length: 9 }).map((_, i) => (
                        <span key={i} className="workspace-loader__tile" />
                    ))}
                </div>
                <div className="workspace-loader__title">{branding?.title ?? "EDE Workspace"}</div>
            </div>
            <div className="workspace-loader__phase">
                {PHASES[phaseIdx]}
                <span className="workspace-loader__dots">
                    <span />
                    <span />
                    <span />
                </span>
            </div>
        </div>
    );
}
